import instanceAPI from 'services/apis/axiosconfig';

export const getDetailExperienceRevive = (id) => {
  const request = instanceAPI.get(`/public/get-experience-revive-detail/${id}`);
  return request.then((res) => ({
    ...res,
    data: {
      results: res.data,
    },
  }));
};
